import { Component, computed, input } from '@angular/core';

type AlertVariant = 'error' | 'info' | 'success' | 'warning';

const VARIANTS: Record<AlertVariant, string> = {
  error:
    'border-red-200 bg-red-50 text-red-700 dark:border-red-900 dark:bg-red-950 dark:text-red-300',
  info: 'border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-900 dark:bg-sky-950 dark:text-sky-300',
  success:
    'border-primary-200 bg-primary-50 text-primary-700 dark:border-primary-900 dark:bg-primary-950 dark:text-primary-300',
  warning:
    'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-300',
};

@Component({
  selector: 'ui-alert',
  template: `
    <div class="mb-4 rounded-lg border px-4 py-3 text-sm font-medium {{ classes() }}" role="alert">
      <ng-content />
    </div>
  `,
})
export class UiAlert {
  readonly variant = input<AlertVariant>('error');

  protected readonly classes = computed(() => VARIANTS[this.variant()]);
}
